export const footer = {
    copyrightText: "Copyright 2024. All Rights Reserved.",
    logo: {
        url: "assets/images/png/logo.png",
        alt: "Logo"
    },
};